<template>
  <div class="breadcrumb-wrapper">
    <a-breadcrumb class="app-breadcrumb">
      <a-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span
          v-if="item.redirect==='noRedirect'||index==levelList.length-1"
          class="no-redirect"
        >{{$t(`moduleTitles.${item.meta.title}`)}}</span>
        <a v-else @click.prevent="handleLink(item)">{{$t(`moduleTitles.${item.meta.title}`)}}</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <a-button class="back-button" @click="handleBack">{{$t('actionTitles.back')}}</a-button>
  </div>
</template>

<script>
import pathToRegexp from "path-to-regexp";

export default {
  data() {
    return {
      levelList: null,
    };
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith("/redirect/")) {
        return;
      }
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );
      this.levelList = matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      );
    },
    pathCompile(path) {
      const { params } = this.$route;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    },
    handleLink(item) {
      const { redirect, path } = item;
      this.$router.push(path);
    },
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.breadcrumb-wrapper {
  position: relative;
  widows: 100vw;
  height: 56px;
  background: #ffffff;
  margin-bottom: 20px;
  // padding:24px;

  .back-button {
    position: absolute;
    right: 10px;
    top: 12px;
    float: right;
  }

  .ant-breadcrumb {
    height: 56px;
    line-height: 56px;
    padding-left: 24px;
  }
  .app-breadcrumb.a-breadcrumb {
    height: 56px;
    display: inline-block;
    font-size: 14px;
    line-height: 56px;
    margin-left: 8px;

    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
}
</style>
